import * as io from 'io-ts';

export const nullableString = io.union([io.null, io.string]);
export const nullableNumber = io.union([io.null, io.number]);
export const arrayOfStrings = io.array(io.string);
export const arrayOfNumbers = io.array(io.number);
export const nullableArrayOfStrings = io.union([io.null, arrayOfStrings]);
